//import cronicleImage from "../../assets/head_cronic.png";
//import { useTranslation } from "react-i18next";
import "../localization/i18n";
//import { useParams } from "react-router-dom";
//import SongBookEditor from "../songbook/SongBookEditor";
//import SongBookList from "../songbook/SongBookList";

const SongBook = () => {
  //const { t } = useTranslation();
  //const params = useParams();
  return (
    <div id="home" className="container-fluid-sm pt-5">
      <div className="row navbar-nav bg-light p-2">
        <div className="text-center">
          <h2>Toto bude paradička</h2>
        </div>
      </div>
      <div><a href="http://zpevnik.oskelt.cz" target="new">Zpěvník</a></div>
      {
      //<SongBookList/>
      //<SongBookEditor id={params.cronicleId} />
      }
    </div>
  );
};

export default SongBook;
